import { useState } from "react";
import { toast } from "sonner";
import { Phone, Mail, Globe, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api, { apiError } from "@/lib/api";

const WHATSAPP = "393382757380";

export default function Contatti() {
  const [form, setForm] = useState({ name: "", business: "", phone: "", email: "", city: "", message: "", request_type: "info" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", business: "", phone: "", email: "", city: "", message: "", request_type: "info" });
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setSending(false); }
  };

  const waLink = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Buongiorno, vorrei ricevere informazioni su MorningBox.")}`;

  return (
    <div>
      <section className="bg-cream">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-orange">Contatti</span>
          <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold text-navy tracking-tight">Parliamone insieme</h1>
          <p className="mt-4 text-lg text-navy/70 max-w-2xl">Hai domande su MorningBox? Scrivici o contattaci direttamente.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid lg:grid-cols-2 gap-10">
        <div className="space-y-4">
          <a href={waLink} target="_blank" rel="noreferrer" data-testid="whatsapp-btn"
            className="flex items-center gap-4 bg-[#25D366] text-white rounded-2xl p-6 hover:opacity-90 transition-opacity">
            <MessageCircle className="w-8 h-8" />
            <div><p className="font-semibold text-lg">Scrivici su WhatsApp</p><p className="text-white/90 text-sm">+39 338 275 7380</p></div>
          </a>
          <div className="bg-white border border-navy/10 rounded-2xl p-6 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-cream flex items-center justify-center"><Phone className="w-6 h-6 text-orange" /></div>
            <div><p className="text-sm text-navy/50">Telefono</p><p className="font-semibold text-navy">338 275 7380</p></div>
          </div>
          <div className="bg-white border border-navy/10 rounded-2xl p-6 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-cream flex items-center justify-center"><Mail className="w-6 h-6 text-orange" /></div>
            <div><p className="text-sm text-navy/50">Email</p><p className="font-semibold text-navy">info@morningbox.it</p></div>
          </div>
          <div className="bg-white border border-navy/10 rounded-2xl p-6 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-cream flex items-center justify-center"><Globe className="w-6 h-6 text-orange" /></div>
            <div><p className="text-sm text-navy/50">Sito</p><p className="font-semibold text-navy">www.morningbox.it</p></div>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white border border-navy/10 rounded-3xl p-8 space-y-4" data-testid="contact-form">
          <h2 className="text-xl font-bold text-navy">Inviaci un messaggio</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label>Nome</Label><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-xl mt-1" data-testid="contact-name" /></div>
            <div><Label>Attività</Label><Input value={form.business} onChange={(e) => setForm({ ...form, business: e.target.value })} className="rounded-xl mt-1" data-testid="contact-business" /></div>
            <div><Label>Telefono</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="rounded-xl mt-1" data-testid="contact-phone" /></div>
            <div><Label>Email</Label><Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-xl mt-1" data-testid="contact-email" /></div>
            <div><Label>Città</Label><Input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="rounded-xl mt-1" data-testid="contact-city" /></div>
            <div>
              <Label>Tipo di richiesta</Label>
              <Select value={form.request_type} onValueChange={(v) => setForm({ ...form, request_type: v })}>
                <SelectTrigger className="rounded-xl mt-1" data-testid="contact-type"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="info">Informazioni</SelectItem>
                  <SelectItem value="bnb">Sono un B&B</SelectItem>
                  <SelectItem value="vendor">Sono un locale</SelectItem>
                  <SelectItem value="support">Assistenza</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div><Label>Messaggio</Label><Textarea required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="rounded-xl mt-1" rows={4} data-testid="contact-message" /></div>
          <Button type="submit" disabled={sending} className="w-full rounded-full bg-navy text-white h-11" data-testid="contact-submit">
            {sending ? "Invio..." : "Invia messaggio"}
          </Button>
        </form>
      </section>
    </div>
  );
}
